import { reduce } from 'lodash'
import i18n from 'app/i18n/i18n'
import {
  FIND_COACHES_URL,
  FIND_EVENTS_URL,
  FIND_ORGANIZATIONS_URL,
  FIND_SPORTSMANS_URL
} from 'components/SportShowCase/_constants/SHOW_CASE_URLS'

const makePersonsMainMenu = (app_person) => reduce(menuItems, (result, value, key) => {

  value.condition
  ? app_person[value.condition] && app_person[value.condition].length && (result[key] = {...value})
  : result[key] = {...value}
  return result
}, {})

const menuItems = {
  events: {
    pathname: FIND_EVENTS_URL,
    get title() { return i18n.t('Events') },
    condition: '',
  },
  sportsman: {
    pathname: FIND_SPORTSMANS_URL,
    get title() { return i18n.t('Athletes') },
    condition: '',
  },
  organization: {
    pathname: FIND_ORGANIZATIONS_URL,
    get title() { return i18n.t('Organizations') },
    condition: '',
  },
  coach: {
    pathname: FIND_COACHES_URL,
    get title() { return i18n.t('Coaches') },
    condition: '',
  },
  judge: {
    pathname: '/find/judges',
    get title() { return i18n.t('Judges') },
    condition: 'judge',
  }
}

export default makePersonsMainMenu
